<template>
  <div class="news_board">
    <div class="tabs">
      <!-- tab 全部 -->
      <div class="tab" :class="{ selected: current_tab_index === -1 }" @click="handleTabClick({}, -1)">全部</div>

      <!-- tab 其他 -->
      <div
        class="tab"
        :key="key"
        v-for="(item, key) in industryZoneData.industryBusiness"
        :class="{ selected: current_tab_index === key }"
        @click="handleTabClick(item, key)"
      >
        {{ item.businessName }}
      </div>
    </div>

    <!-- list 全部 -->
    <template v-if="current_tab_index === -1">
      <!-- list -->
      <div class="list_container">
        <a
          class="item"
          :key="key"
          v-for="(item, key) in industryZoneData.industryData.list"
          target="_blank"
          :href="`${INDUSTRY_ZONE_DETAIL_URL}?id=${item.contentId}&industryId=${industryZoneData.id}&industrySearch=${keywords}`"
          v-track
          :data-oid="OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_BOARD_NEWS_CLICK"
          :data-cid="item.contentId"
        >
          <div class="left" v-html="item.title" />
          <div class="right">{{ item.publishTime }}</div>
        </a>
      </div>

      <!-- 查看更多 -->
      <a
        target="_blank"
        class="view_more"
        :href="`${INDUSTRY_ZONE_URL}?special=${keywords}&industryId=${industryZoneData.id}&businessId=`"
        v-track
        :data-oid="OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_VIEW_MORE_CLICK"
        :data-cid="industryZoneData.id"
        :data-extendinfo="0"
      >
        查看全部 {{ industryZoneData.industryData.totalSize }} 条「{{ industryZoneData.industryName }}」信息 >
      </a>
    </template>

    <!-- list 其他 -->
    <template v-if="current_tab_index !== -1">
      <!-- list -->
      <div class="list_container" v-if="industryDataOtherTab.list.length">
        <a
          class="item"
          :key="key"
          v-for="(item, key) in industryDataOtherTab.list"
          target="_blank"
          :href="`${INDUSTRY_ZONE_DETAIL_URL}?id=${item.contentId}&industryId=${industryZoneData.id}&industrySearch=${keywords}`"
          v-track
          :data-oid="OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_BOARD_NEWS_CLICK"
          :data-cid="item.contentId"
        >
          <div class="left" v-html="item.title" />
          <div class="right">{{ item.publishTime }}</div>
        </a>
      </div>

      <div class="list_container empty" v-else>
        <i class="iconfont icon-spinner" />
      </div>

      <!-- 查看更多 -->
      <a
        target="_blank"
        class="view_more"
        :href="`${INDUSTRY_ZONE_URL}?special=${keywords}&industryId=${industryZoneData.id}&businessId=${industryZoneData.industryBusiness[current_tab_index].businessId}`"
        v-track
        :data-oid="OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_VIEW_MORE_CLICK"
        :data-cid="industryZoneData.id"
        :data-extendinfo="industryZoneData.industryBusiness[current_tab_index].businessId"
      >
        查看全部 {{ industryDataOtherTab.totalSize }} 条「{{
          industryZoneData.industryBusiness[current_tab_index].businessName
        }}」信息 >
      </a>
    </template>
  </div>
</template>

<script>
import { INDUSTRY_ZONE_DETAIL_URL, INDUSTRY_ZONE_URL } from "@/utils/constants/constants.industry-zone";
import { restAccountIndustrySearch } from "@/services/common/industry-zone";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";

export default {
  name: "IndustryZoneNewsBoard",
  data() {
    return {
      current_tab_index: -1,
      INDUSTRY_ZONE_DETAIL_URL,
      INDUSTRY_ZONE_URL,
      OID_MAP,
    };
  },
  computed: {
    // 全部分类 以及 整体数据
    industryZoneData() {
      return this.$store.getters["industryZone/industryZoneData"];
    },
    keywords() {
      return this.$store.getters["search/searchParams"].keywords;
    },
    // 其他分类
    industryDataOtherTab() {
      return this.$store.getters["industryZone/industryDataOtherTab"];
    },
  },
  methods: {
    async handleTabClick(item, key) {
      this.current_tab_index = key;
      if (this.current_tab_index === -1) {
        // 全部 分类，不拉接口
        this.$track(DEED_MAP.CLICK, OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_TAB_TITLE_CLICK, {
          extendinfo: "全部",
        });
        return;
      }
      // 其他分类的list数据
      const res = await restAccountIndustrySearch({
        businessIdList: [item.businessId],
        industryId: this.industryZoneData.id,
      });
      this.$store.commit("industryZone/updateIndustryDataOtherTab", res.data);
      this.$track(DEED_MAP.CLICK, OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_TAB_TITLE_CLICK, {
        extendinfo: this.industryZoneData.industryBusiness[this.current_tab_index].businessName,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/config";

.news_board {
  width: 460.5px;
  height: 250px;
  background: rgba(6, 15, 60, 0.8);
  border-radius: 4px;
  padding: 14px 25px 20px 25px;
  display: flex;
  flex-direction: column;

  .tabs {
    display: flex;
    justify-content: space-between;

    .tab {
      cursor: pointer;
    }

    .selected {
      border-bottom: 2px solid white;
    }
  }

  .list_container {
    margin-top: 10px;

    .item {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      margin-top: 12px;
      line-height: 17px;
      font-weight: 700;

      .left {
        width: 320px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #b0b6ca;
      }

      .right {
        color: #b0b6ca;
      }
    }
  }

  .empty {
    height: 147px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      color: #b0b6ca;
      font-size: 20px;
      animation: rotate 1s linear infinite;
    }

    @keyframes rotate {
      from {
        transform: rotate(0);
      }

      to {
        transform: rotate(360deg);
      }
    }
  }

  .view_more {
    color: $industry-zone-theme-color;
    margin-top: 20px;
    text-align: center;
  }
}
</style>
